<form class="cog-search" role="search" (submit)="submit($event)">
  <i class="pi pi-search cog-search__icon" aria-hidden="true"></i>
  <input
    class="cog-search__input"
    type="text"
    autocomplete="off"
    placeholder="Tem uma dúvida? Pergunte ao Cog"
    aria-label="Pergunte ao Cog"
    [value]="question()"
    (input)="onInput($event)" />
  <button
    type="submit"
    class="cog-search__submit"
    aria-label="Perguntar ao Cog"
    title="Perguntar ao Cog"
    [disabled]="!question().trim()">
    <i class="pi pi-arrow-up" aria-hidden="true"></i>
  </button>
</form>
